import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Phone = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="phone icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92 2C11.53 2 12.64 2.8 13.22 3.46C14.01 4.35 17.97 9.76 17.97 9.76C19.04 10.84 19.11 12.52 18.11 13.51L13.71 17.91C13.34 18.28 12.87 18.51 12.37 18.59C17.02 25.58 22.31 30.85 29.27 35.49C29.35 34.99 29.57 34.52 29.95 34.15L34.35 29.75C34.82 29.28 35.45 29.04 36.1 29.04C36.81 29.04 37.54 29.33 38.11 29.89C38.11 29.89 43.06 33.59 44.32 34.55C45.58 35.51 46.55 36.99 45.67 39.51C44.82 41.94 41.11 45.85 35.97 45.85C35.97 45.85 35.96 45.85 35.95 45.85C27.85 45.85 14.3 33.2 14.3 33.2C14.3 33.2 2.02 21.85 2.02 11.9C2 5.85 5.57 3.2 8 2.35C8.7 2.1 9.34 2 9.92 2ZM9.92 0C9.08 0 8.21 0.15 7.34 0.46C1.93 2.35 0 7.61 0 11.9C0 22.6 12.39 34.18 12.92 34.67C13.05 34.8 16.44 37.95 20.9 41.15C27.09 45.6 32.14 47.85 35.93 47.85C42.02 47.85 46.46 43.27 47.54 40.17C48.56 37.25 47.86 34.76 45.52 32.96C44.35 32.06 40.12 28.9 39.39 28.36C38.49 27.52 37.29 27.04 36.09 27.04C34.89 27.04 33.76 27.5 32.93 28.34L28.64 32.63C23.28 28.81 19.04 24.57 15.23 19.22L19.52 14.93C21.26 13.2 21.24 10.33 19.5 8.47C18.83 7.56 15.5 3.03 14.71 2.14C13.52 0.78 11.77 0 9.92 0Z"
    />
  </svg>
)
